<template>
	<div class="gb-list" :class="classList">
		<GBScheduleListRowGroup
			v-for="item in items"
			v-bind:key="item.codeWithType"
			v-bind:scroll_to="scroll_to"
			v-bind:narrow="narrow"
			v-bind:item=item
			v-bind:isEditable="isEditable"
			v-bind:watchSlide="watchSlide"
			v-bind:use_photo="use_photo"
			v-bind:ghost_schedule="ghost_schedule"
			v-on:schedule-list-row-slide="onScheduleListRowSlide"
			v-on:show-project-info="onClickShowProjectInfo"
			v-on:show-member-info="onClickShowMemberInfo"
			v-on:show-add-member="onClickShowAddMember"
			v-on:update-dataset="onUpdateDataSet"
			v-on:delete-member-from-project="onDeleteMemberFromProject"
		/>
	</div>
</template>
<script>
import GBScheduleListRowGroup from './GBScheduleListRowGroup';
export default {
	name: 'GBScheduleList',
	props: [
		"items",
		"isEditable",
		"narrow",
		"scroll_to",
		"use_photo",
		"ghost_schedule",
	],
	components: {
		GBScheduleListRowGroup,
	},
	data() {
		return {
			watchSlide: null,
		};
	},
	methods: {
		onClick: function(e) {
			this.watchSlide = {
				type: 'click',
				target: e,
				status: null,
			};
		},
		onScheduleListRowSlide: function(e) {
			this.watchSlide = {
				type: 'slide',
				target: e.target,
				status: e.status,
			};
		},
		onClickShowProjectInfo: function(e) {
			this.$emit("show-project-info", e);
		},
		onClickShowMemberInfo: function(e) {
			this.$emit("show-member-info", e);
		},
		onClickShowAddMember: function(e) {
			this.$emit("show-add-member", e);
		},
		onUpdateDataSet: function() {
			this.$emit("update-dataset");
		},
		onDeleteMemberFromProject: function(e) {
			this.$emit("delete-member-from-project", e);
		},
	},
	computed: {
		classList: function() {
			let classes = new Array();

			if (this.narrow)
				classes.push('narrow');

			return classes;
		},
	},
	mounted: function() {
		window.addEventListener('click', this.onClick, false);
	},
	beforeDestory: function() {
		window.removeEventListener('click', this.onClick, false);
	},
}
</script>
<style>
	.gb-list {
		flex: 0 0 299px !important;
		background-color: white;
		z-index: 101;
		border-right: 1px solid #dfdfdf;
	}
	.gb-list.narrow {
		flex: 0 0 243px !important;
	}
</style>
